module.exports = __webpack_public_path__ + "img/pay-alipay-eg.dd45eeee.jpg";